import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../store/index';
import DashboardTable from '../../../components/DashboardTable/DashboardTable';
import { formatDateMMDDYYYY } from '../../../utils/formatters';
import ProfileInviteCandidateButton from './ProfileInviteCandidateButton';
import { generateImageSource } from '../../../utils/generateImageSource';

const columnHeaders = [
  {
    value: 'Job Posting Title',
    key: 'title',
    className: 'p2p-table__no-wrap',
    sortable: true
  },
  {
    value: 'Date Created',
    key: 'postedDate',
    className: 'p2p-table__centered',
    sortable: true
  },
  {
    value: 'Applicants',
    key: 'applicantCount',
    className: 'p2p-table__centered',
    sortable: true
  },
  {
    value: 'Invite to Apply',
    key: 'invite',
    className: 'p2p-table__centered'
  },
  {
    value: '',
    key: 'selectedCheck',
    className: 'p2p-table__check'
  }
];

const DesktopInviteCandidateTable = () => {
  const {
    bulkJobInvitationStore: {
      jobPostings,
      sort,
      setSort,
      selectedJobIds,
      addSelectedJob,
      removeSelectedJob
    }
  } = useStore();

  const handleSortChange = ({ by, order }) => {
    setSort({ by, order });
  };

  const enrichData = (data) => {
    const enrichedData = [];
    data.forEach((row) => {
      let selected = false;
      if (Array.isArray(selectedJobIds) && selectedJobIds.length) {
        selected = selectedJobIds.includes(row.jobPostingId);
      }
      const enrichedRow = { ...row };
      enrichedRow.postedDate = formatDateMMDDYYYY(new Date(row.postedDate));
      enrichedRow.invite = (
        <ProfileInviteCandidateButton
          invitable={!row.candidateExistsInApplicants}
          addJob={addSelectedJob}
          removeJob={removeSelectedJob}
          jobId={row.jobPostingId}
          selected={selected}
        />
      );
      enrichedRow.selectedCheck = (selected
        && (
          <img
            src={generateImageSource('/images/v1/path-to-pro/success_icon_green.svg')}
          />
        )
      );
      enrichedData.push(enrichedRow);
    });
    return enrichedData;
  };

  return (
    <div className="p2p-invite-candidate-modal__table">
      <DashboardTable
        data={enrichData(jobPostings)}
        sort={sort}
        handleSortChange={handleSortChange}
        columnHeaders={columnHeaders}
      />
    </div>
  );
};

export default observer(DesktopInviteCandidateTable);
